import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pf0011',
    ecrans: ['00-2'],
    params: ['id']
});
